
<template>
  <div class="container">
	  <!-- // <template>
// 	<div style="text-align: center;">
// 		<div style="color: #909090;font-size: 20px;">功能正在开发中…</div>
// 		<img src="../../../public/kaifa.png" />
// 	</div>
// </template> -->
<!-- v-if="queryEnable" -->
      <div class="container-top" >
      <!-- <a-select class="a_input_self margin_self" allowClear placeholder="请选择公司" v-model="queryParam.companyId" @change="handlecompanyplan" >
        <a-select-option :value="item.value" v-for="(item, index) in companylist" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select> -->
      <!-- <a-tree-select  class="a_input_self margin_self"  allowClear  :treeData="deptTree"  placeholder="请选择部门" @change="getUserInfor"
       v-model="queryParam.deptId" > </a-tree-select>
      <a-select allowClear placeholder="请选择人员" v-model="queryParam.userName" class="a_input_self margin_self" >
        <a-select-option :value="item.userId" v-for="(item, index) in users" :key="index">
          {{ item.userName }}
        </a-select-option>
      </a-select> -->
          	<!-- <a-input v-model="secrchData.name" style="margin-left: 10px;" allowClear class="a_input_self margin_self" placeholder="请输入姓名" @keyup.enter.native="query"/> -->
      <a-input placeholder="请输入姓名" allowClear class="a_input_self margin_self" v-model="queryParam.userName" @keyup.enter.native="query"/>
	    <a-button type="primary" @click="query"> 查询 </a-button>
       <a-button  @click="rest"> 重置 </a-button>
      </div>
      <div  class="content_main_center_scroll1"  id="content_main_center_scroll1">
        <a-table
          :data-source="attendanceList"
          bordered
          :loading="loading"
          :pagination="false"
          :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
        >
          <a-table-cloumn  title="序号" width="80px">
              <template slot-scope="text, record, index">
                  {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
              </template>
          </a-table-cloumn>
          <a-table-column key="clockInDate" title="日期" ellipsis="true" data-index="clockInDate" />
          <a-table-column key="createByName" title="姓名" ellipsis="true" data-index="createByName" /> 
          <a-table-column key="company" title="所属公司" ellipsis="true" data-index="company" width="300px"/>
          <a-table-column key="factory" title="企事业名称" ellipsis="true" data-index="factory" width="300px"/>   
          <!-- <a-table-column key="carCode" title="拜访人姓名电话号码" ellipsis="true" data-index="carCode" /> -->
          <a-table-column key="address" title="拜访打卡地址" ellipsis="true" data-index="address" width="300px"/> 
          <a-table-column key="daily" title="日志" ellipsis="true" >
              <template slot-scope="text, record">
                  <a @click="detail(record)">查看当天日志</a>
                  <!-- <a-divider type="vertical" />
                  <a @click="historyRecord(record)">历史</a> -->
                  <!-- <a-button type="link" @click="changeInfo(record)"> 编辑 </a-button> -->
              </template>
          </a-table-column>
        </a-table>
        <div class="content_main_center_scroll_bottom">
          <a-pagination v-model="pagination.current" show-size-changer :page-size.sync="pagination.pageSize" :total="pagination.totalCount" style="margin-top: 10px;"
            @showSizeChange="showSizeChange" :pageSizeOptions="['10', '20', '30', '50']" @change="onShowSizeChange" />
        </div>
      </div>
      	<a-modal title="日志详情" :visible="visible" @cancel="visible = false" width="50%">
          <div>
            <div style="display:flex;justify-content: space-between;">
              <span>业务员：{{visibleData.createBy}}</span>
              <span>日志日期：{{visibleData.dailyTime}}</span>
            </div>
            <div  style="display:flex;justify-content:center;align-items: center;margin-top:20px;">
              <span style="display:inline-block;width:80%;">
                  拜访日志：{{visibleData.finishWork}}
              </span>
            </div>
          </div>
          <template slot="footer">
            <a-button key="back" @click="visible = false"> 取消 </a-button>
            <!-- <a-button key="submit" type="primary" @click="contractOk"> 提交 </a-button> -->
          </template>

        </a-modal>
      

  </div>
</template>

<script>
import {	checkPermission	} from '@/utils/permissions'
// import { limitCompany } from '@/utils/limitCompany'
// import { tree_all } from '@/api/purchase'
import { getUserList, getDeptListEnable2, list_page, getDailyOne } from '@/api/system'
export default {
    data() {
			return {
        visibleData: {},
        visible: false,
        //分页数据
            pagination: { //分页数据
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                current: 1,
                pageSize: 10,
                totalCount: 0
            },
          // pageSize: 10,
          // current: 1,
          // total: 0,
          scroll_y: 150,
          queryParam: {
            // companyId: undefined,
            // deptId: undefined,
            userName: undefined,
          },
          companylist: [],
          deptTree: [],
          users: [],
          attendanceList: [],
          queryEnable: checkPermission('daily:attendance:query'), //解绑微信
          }
        },
    created() {
      // this.getData()
      // this.getUserInfor(this.$store.getters.userInfo.deptId)
      this.query()
    },
    mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll1').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 100
				}, 1000)
        console.log(max_h,this.scroll_y, 'max_h=======================')
			})
		},
    methods: {
      //产看当天日志
      detail(data) {
        getDailyOne({
          dailyTime: data.clockInDate,
          userId: data.userId
        }).then(res => {
          if(res.code == 200) {
            this.visibleData = res.data
            this.visible = true

          }else {
            this.$message.error(res.msg)

          }

        })

      },
      //重置
      rest() {
        this.queryParam = {
            // companyId: undefined,
            // deptId: undefined,
            userName: undefined,
          }
        this.query()
      },
      //查询
        query() {
          list_page({
            pageNum: this.pagination.current,
					  pageSize: this.pagination.pageSize,
            // company: this.queryParam.deptId,
            createByName: this.queryParam.userName
          }).then(res => {
            if(res.code == 200) {
              res.data.list.forEach(item => {
                if(item.clockInDate) {
                   item.clockInDate =  item.clockInDate.trim().split(" ")[0]
                }
              })
              this.attendanceList = res.data.list
              this.pagination.totalCount = res.data.totalCount
            } else {
              this.$message.error(res.msg)
            }
          })
        },
        buildtree2(list, arr, parentId) {
          list.forEach((item) => {
            if (item.parentId === parentId) {
              var child = {
                key: item.deptId,
                value: item.deptId, // value是给modal的select用的，2者属性不一样
                title: item.deptName,
                scopedSlots: {
                  title: 'title',
                },
                children: [],
              }
              this.buildtree2(list, child.children, item.deptId)
              if (child.children.length === 0) {
                delete child.children
              }
              arr.push(child)
            }
          })
        },
        getData() {
          // tree_all().then((res) => {
    	    //    if (res.code == 200) {
    	    //       this.companyData = res.data[0]
          //    }
          // })
          getDeptListEnable2().then((res) => {
            const data = res.rows
            if (data.length > 0) {
              const min = Math.min(...data.map((m) => m.parentId))
              this.buildtree2(data, this.deptTree, this.$store.getters.userInfo.companyId)
            }
          })
          // limitCompany().then(res => {
          //     res.forEach(item => {
          //       if (item.deptId) {
          //         this.companylist.push(item)
          //       }
          //     })
          //     this.companylist.forEach(item => {
          //       if (item.deptId == this.$store.state.user.info.companyId) {
          //         this.deptTree = item.children
          //       }
          //     })
          // })
        },
        getUserInfor(e) {
          if(this.queryParam.userName) {
            this.queryParam.userName = undefined
          }
          // 获取当前部门的人员信息
          getUserList({
            deptId: e
          }).then(res => {
            if(res.code == 200){
              this.users = res.rows
            } else {
              this.$message.error(res.msg)
            }
          })
        },
        showSizeChange(current, pageSize) {
          this.pagination.pageSize = pageSize
          this.pagination.current = current
          // this.get_lis()
          // 刷新列表
          this.query()
        },
        onShowSizeChange(current, pageSize) {
          // this.selectedRowKeys = []
          // this.selectedRow = []
          this.pagination.current = current
          this.query()
          // this.get_lis()
        },
        
    }

}
</script>

<style lang="less" scoped>
.container {
    margin: 10px;
    .container-top {
        margin: 10px 0;
		padding: 10px 0;
    }
    .content_main_center_scroll1 {
      width: 100%;
      height: calc(100vh - 150px);
      float: left;
      overflow: hidden;
      // background-color: blue;
    }
    .content_main_center_scroll_bottom {
      position: absolute;
      right: 10px;
    }

}

</style>
